export const DUMMY_ASSIGNMENTS = [
  {
    id: 378,
    created_at: 1698700538033,
    title:
      'Represent constraints by equations or inequalities, and by systems of equations and/or inequalities, and interpret solutions as viable or nonviable options in a modeling context.',
    subject_id: 1,
    grades_id: 9,
    user_id: 0,
    school_id: 57,
    open_time: 1698700534977,
    close_time: 1699308934977,
    classroom_id: 306,
    substitute_teacher_user_id: 0,
    classroom: {
      id: 306,
      created_at: 1698690557790,
      code: 'hEsmTnCS',
      name: '8th Grade',
      description: 'Algebra I for 7th Grade Class',
      grades_id: 10,
      subject_id: [1],
      user_id: 3723,
      test_day: 5,
      isArchive: 0,
      new_user_ids: [],
    },
    subject: {
      id: 1,
      created_at: 1667470488260,
      subject: 'Algebra I',
    },
    grade: {
      id: 10,
      created_at: 1667469815472,
      grade: '8th',
    },
  },
  {
    id: 379,
    created_at: 1698700746636,
    title: 'Solve quadratic equations in one variable.',
    subject_id: 1,
    grades_id: 9,
    user_id: 0,
    school_id: 57,
    open_time: 1698700743567,
    close_time: 1699309143567,
    classroom_id: 306,
    substitute_teacher_user_id: 0,
    classroom: {
      id: 306,
      created_at: 1698690557790,
      code: 'hEsmTnCS',
      name: '8th Grade',
      description: 'Algebra I for 7th Grade Class',
      grades_id: 9,
      subject_id: [1],
      user_id: 3723,
      test_day: 5,
      isArchive: 0,
      new_user_ids: [],
    },
    subject: {
      id: 1,
      created_at: 1667470488260,
      subject: 'Algebra I',
    },
    grade: {
      id: 10,
      created_at: 1667469815472,
      grade: '8th',
    },
  },
];
